import {
	Component,
	ComponentFactoryResolver,
	OnDestroy,
	OnInit,
} from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BroadcastService } from "../../../../shared/services/broadcast.service";
import { NRModalService } from "../../../../shared/modal/services/nrmodal.service";
import { SwalService } from "../../../../shared/services/swal.service";
import { UnitssService } from "../../../../services/unitss.service";
import { Subject } from "rxjs";
import {
	EventModel,
	EventSubscriptionType,
	EventType,
} from "../../../../shared/interfaces/event.model";
import { takeUntil } from "rxjs/operators";
import { DynamicHostModel } from "../../../../shared/modal/models/dynamic-host.model";
import { CustomersService } from "../../../../services/customers.service";
import { ControlService } from "../../../../services/control.service";

import * as ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { UsersService } from "../../../../services/users.service";
import { EditCreateMediaClientsComponent } from "./edit-create-media-clients/edit-create-media-clients.component";
import { MediasService } from "../../../../services/medias.service";
import { MediaClientsService } from "../../../../services/media-clients.service";

interface DataTableColumn {
	title: string;
	field: string;
	type?: string;
	default?: any;
}

@Component({
	selector: "app-media-client",
	templateUrl: "./media-client.component.html",
	styleUrls: ["./media-client.component.scss"],
})
export class MediaClientComponent implements OnInit {
	data: any = {};
	isLoading: boolean = false;

	showClientModal = false;
	selectedClient: number | null = null;

	public UsersSocket = null;

	dtConfig = {
		config: {
			base: this.mediaclientService,
			is_alive: true,
			usersSocket: this.userService,
			api: "datatable",
			rowsPerPage: 10,
			order: [[2, "desc"]],
			params: {
				key: "",
				client_id: null,
			},
			hasCustomProcessData: true,
			processValues: async (response) => {
				response.data.map((unit: any) => {
					unit.client_name =
						this.clientesMap.get(unit.client_id) ||
						"Cliente no asociado";

					// unit.active = unit.active == 1 ? "Activo" : "Inactivo";

					return unit;
				});
				return response;
			},
		},
		columns: [],
		actions: [],
	};
	isAdmin: boolean = false;
	clientes: any = {};
	clientesMedia: any = {};
	selectedClientId: number | null = null;
	private atComponentDestroy = new Subject();
	private clientesMap = new Map<number, string>();

	constructor(
		public modalRef: BsModalService,
		private componentFactoryResolver: ComponentFactoryResolver,
		private broadcast: BroadcastService,
		private nrModal: NRModalService,
		private swal: SwalService,
		private unitsService: UnitssService,
		private customersService: CustomersService,
		private controlservice: ControlService,
		private userService: UsersService,
		private mediaclientService: MediaClientsService,
	) {}
	clearClientFilter(): void {
		this.selectedClientId = null;
		delete this.dtConfig.config.params.client_id;
		this.broadcast.reloadDataTable();
	}

	onClientChange(): void {
		if (this.selectedClientId) {
			this.dtConfig.config.params.client_id = this.selectedClientId;
		} else {
			delete this.dtConfig.config.params.client_id;
		}
		this.broadcast.reloadDataTable();
	}

	async ngOnInit(): Promise<void> {
		this.clientesMedia = await this.mediaclientService.datatable();
		console.log(this.clientesMedia);
		await this.controlservice.isAdmin().subscribe(async (res) => {
			this.isAdmin = res.is_admin;

			// ← Acciones condicionales según rol
			this.dtConfig.actions = this.isAdmin
				? [
						{
							display: "Editar",
							icon: "fa-pencil",
							event: "media-client.edit",
							conditionality: "true",
						},
						{
							display: "Eliminar",
							icon: "fa-trash",
							event: "media-client.delete",
							conditionality: "true",
						},
					]
				: [];

			this.UsersSocket = this.userService;

			// ← Columnas condicionales
			this.setupColumns();

			this.customersService.datatable(1, {}).subscribe((res: any) => {
				if (res?.data) {
					this.clientes = res.data;
					res.data.forEach((cliente) => {
						this.clientesMap.set(
							cliente.id,
							cliente.nombre_comercial ?? cliente.name,
						);
					});
					this.broadcast.reloadDataTable();
				}
			});

			// ← Escuchar eventos
			this.broadcast
				.onEvent(EventSubscriptionType.TYPE, EventType.MODAL)
				.pipe(takeUntil(this.atComponentDestroy))
				.subscribe(async (event: EventModel) => {
					const props = await this.prepareProps(event);
					if (props) {
						this.nrModal.open(props);
					}
				});
		});
	}

	showUsersSocket(): void {}

	ngOnDestroy(): void {
		this.atComponentDestroy.next();
		this.atComponentDestroy.unsubscribe();
	}

	setupColumns(): void {
		const columns: DataTableColumn[] = [];
		if (this.isAdmin) {
			columns.push({ title: "ID", field: "id" });
		}

		columns.push(
			{ title: "Nombre", field: "name"},
			{ title: "Razon Social", field: "legal_name"},
			{title: "Representante", field: "contact_name"},
			{ title: "Número Telefónico", field: "phone_number"},
			{ title: "Cliente", field: "client_name"},
		);


		columns.push({title: "Correo Electrónico", field: "email"});

		this.dtConfig.columns = columns;
	}

	async prepareProps(event: EventModel): Promise<any> {
		const props: DynamicHostModel = new DynamicHostModel();
		props.instantiated = false;
		event.data.item = event.data.item || {};

		props.modalModel = {
			component: null,
			componentFactoryResolver: this.componentFactoryResolver,
			data: event.data.item || {},
		};

    console.log(props.modalModel.data)

		switch (event.name) {
			case "media-client.add":
				props.modalModel.component = EditCreateMediaClientsComponent;
				props.modalModel.modalConfiguration = {
					title: "Agregar Unidad",
				};
				break;

			case "media-client.edit":
				props.modalModel.component = EditCreateMediaClientsComponent;
				props.modalModel.modalConfiguration = {
					title: "Editar Unidad",
				};
				break;
			case "media-client.delete":
				this.delete(event.data);
				return false;
		}

		return props;
	}

	add(): void {
		this.broadcast.fire({
			name: "unitss.add",
			type: EventType.MODAL,
			data: {},
		});
	}

	delete(data): void {
		const swalParams = {
			title: "¿Estás seguro de querer eliminarlo?",
		};

		this.swal.warning(swalParams).then((result) => {
			if (result.value) {
				this.unitsService
					.delete(data.item.id)
					.subscribe((resp: any) => {
						if (resp.success) {
							this.swal
								.success({
									title: "Unidad eliminada exitosamente",
								})
								.then(() => {
									this.modalRef.hide(0);
									this.broadcast.reloadDataTable();
								});
						} else {
							this.swal.error(
								"Ocurrió un error al intentar borrar la unidad",
							);
						}
					});
			}
		});
	}

	async loadUnits(clientId: number | null): Promise<void> {
		try {
			if (clientId) {
				this.data = await this.unitsService.getUnitsByClient(clientId);
			} else {
				this.data = await this.unitsService.getUnitsFlat();
			}
		} catch (err) {
			console.error("Error al obtener unidades", err);
		}
	}

	async openModalClient() {
		let data;
		try {
			data = await this.customersService.getAll();
			this.clientes = data.data;
		} catch (err) {
			console.error("Error al obtener unidades", err);
		}
		this.showClientModal = true;
	}

	handleClientSelection(clientId: number | null) {
		this.selectedClient = clientId;
		this.showClientModal = false;
		this.generateReport(clientId);
	}

	async generateReport(clientId: number | null): Promise<void> {
		this.isLoading = true;
		await this.loadUnits(clientId);
		if (!this.data) return;

		const workbook = new ExcelJS.Workbook();

		// === Hoja Conectados ===
		const connectedSheet = workbook.addWorksheet("Conectados");
		const clienteSeleccionado = this.clientes.find(
			(c) => c.id === clientId,
		);
		const connectedData = (this.data.connected || []).map((item) => ({
			...item,
			bw: this.formatBw(item.bw),
			last_connection: this.formatDateTime(item.last_connection),
			client_name: this.clientes.find((c) => c.id === item.client_id)
				.name,
		}));

		const connectedColumns: any[] = [
			{ header: "ID", key: "id", width: 6 },
			{ header: "Nombre", key: "name", width: 20 },
			{ header: "Linea asignada", key: "Phone_number", width: 20 },
			{ header: "Cliente", key: "client_name", width: 15 },
			{ header: "Consumo (GB)", key: "bw", width: 15 },
			{ header: "Última conexión", key: "last_connection", width: 30 },
			{ header: "Evidencia", key: "evidencia", width: 30 },
		];
		connectedSheet.columns = connectedColumns;

		for (const item of connectedData) {
			const row = connectedSheet.addRow(item);
			row.height = 100;

			// Insertar imagen
			if (item.lastEvidence?.url) {
				try {
					const proxyUrl = item.lastEvidence.url; // usar URL completa en producción

					const base64 = await this.getBase64Image(proxyUrl);

					const imageId = workbook.addImage({
						base64: base64,
						extension: "png",
					});

					connectedSheet.addImage(imageId, {
						tl: {
							col: connectedColumns.findIndex(
								(c) => c.key === "evidencia",
							),
							row: row.number - 1,
						},
						ext: { width: 100, height: 100 },
					});
				} catch (error) {
					console.warn(
						"No se pudo obtener la imagen:",
						item.lastEvidence.url,
						error,
					);
					// simplemente omitimos la imagen
				}
			}
		}

		// === Hoja Desconectados ===
		const disconnectedSheet = workbook.addWorksheet("Desconectados");
		const disconnectedData = (this.data.disconnected || []).map((item) => ({
			...item,
			bw: this.formatBw(item.bw),
			last_connection: this.formatDateTime(item.last_connection),
			client_name: this.clientes.find((c) => c.id === item.client_id)
				.name,
		}));

		const disconnectedColumns: any[] = [
			{ header: "ID", key: "id", width: 6 },
			{ header: "Nombre", key: "name", width: 20 },
			{ header: "Linea asignada", key: "Phone_number", width: 20 },
			{ header: "Cliente", key: "client_name", width: 15 },
			{ header: "Consumo (GB)", key: "bw", width: 15 },
			{ header: "Última conexión", key: "last_connection", width: 30 },
		];
		disconnectedSheet.columns = disconnectedColumns;

		for (const item of disconnectedData) {
			disconnectedSheet.addRow(item);
		}

		// === Guardar libro ===
		const buf = await workbook.xlsx.writeBuffer();
		const blob = new Blob([buf], {
			type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
		});
		this.isLoading = false;
		const fechaHora = `${new Date().getFullYear()}-${(
			new Date().getMonth() + 1
		)
			.toString()
			.padStart(2, "0")}-${new Date()
			.getDate()
			.toString()
			.padStart(2, "0")} ${new Date()
			.getHours()
			.toString()
			.padStart(2, "0")}:${new Date()
			.getMinutes()
			.toString()
			.padStart(2, "0")}:${new Date()
			.getSeconds()
			.toString()
			.padStart(2, "0")}`;
		saveAs(
			blob,
			`ReporteUnidades_${
				clienteSeleccionado != null
					? clienteSeleccionado.name
					: "General"
			}_${fechaHora}.xlsx`,
		); //ReporteUnidades_cliente_fecha_hora ´´
	}

	formatDateTime(datetime: string | null): string {
		if (!datetime) return ""; // manejar valores nulos o vacíos

		const date = new Date(datetime);

		// 🔹 Restar 6 horas ANTES de formatear
		const adjusted = new Date(date.getTime() - 6 * 60 * 60 * 1000);

		const pad = (n: number) => n.toString().padStart(2, "0");

		const day = pad(adjusted.getDate());
		const month = pad(adjusted.getMonth() + 1); // los meses van de 0 a 11
		const year = adjusted.getFullYear();

		const hours = pad(adjusted.getHours());
		const minutes = pad(adjusted.getMinutes());
		const seconds = pad(adjusted.getSeconds());

		return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
	}

	async getBase64Image(url: string): Promise<string> {
		// return new Promise((resolve, reject) => {
		//     const img = new Image();
		//     img.crossOrigin = 'anonymous';
		//     img.onload = () => {
		//     const canvas = document.createElement('canvas');
		//     canvas.width = img.width;
		//     canvas.height = img.height;
		//     const ctx = canvas.getContext('2d');
		//     ctx!.drawImage(img, 0, 0);
		//     resolve(canvas.toDataURL('image/png').split(',')[1]); // quitar el "data:image/png;base64,"
		//     };
		//     img.onerror = reject;
		//     img.src = url;
		// });
		const response = await fetch(url, { credentials: "include" });
		const blob = await response.blob();

		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.onloadend = () => {
				resolve((reader.result as string).split(",")[1]); // quitar el prefijo data:
			};
			reader.onerror = reject;
			reader.readAsDataURL(blob);
		});
	}

	formatBw(bytes: any): string {
		const value = Number(bytes);
		return isNaN(value) ? "0 GB" : (value / 1024 ** 3).toFixed(2) + " GB";
	}
}
